export default function ExamplesEditController(
  ExamplesService,
  FlashService,
  PartnerService
) {
  var vm = this;

  var initialize = function initialize() {
    vm.examplesService = ExamplesService;
    vm.examplesService.getExamples();
    vm.partnerService = PartnerService;
    vm.flashService = FlashService;

    vm.partnerService.get().then(function(partner) {
      vm.partner = partner;
    });
  };

  vm.save = function save() {
    return vm.examplesService.saveExamples().then(
      () => {
        vm.flashService.push('success', 'Your changes have been saved.');
      },
      response => {
        if (response.status === 403) {
          vm.flashService.push(
            'error',
            "You don't have permission to edit this partner."
          );
        } else {
          vm.flashService.push('error', 'Something went wrong!');
        }
      }
    );
  };

  vm.newExample = function newExample(demoId) {
    vm.examplesService.newFromDemo(demoId);
  };

  initialize();
  return vm;
}

ExamplesEditController.$inject = [
  'ExamplesService',
  'FlashService',
  'PartnerService'
];
